import PriceModifiersList from "./PriceModifiersList";
import { withMultipleQueryData } from "../../../../../common/withQueryData";
import { useNavigate } from "react-router-dom";
import { usePropertyId } from "../../../../../common/hooks/usePropertyId";
import { useRoomsData } from "../../../../../common/hooks/useRoomsData";
import { usePlansData } from "../../../../../common/hooks/useRatePlansData";
import { usePriceModifiersData } from "../../../../../common/hooks/usePriceModifiersData";
import { Box, Typography } from "@mui/material";
import { OrdinaryButton } from "../../../../../common/Buttons";
import { useAlertNotification } from "../../../../../common/hooks/useAlertNotification";

const PriceModifiersPage = () => {
    const propertyId = usePropertyId();

    const { setAlert } = useAlertNotification();

    const { queryResults: roomsQueryResults } = useRoomsData(propertyId);
    const { queryResults: plansQueryResult } = usePlansData(propertyId);
    const { queryResults: priceModifiersQueryResult, deleteModifier } = usePriceModifiersData(propertyId);

    const onModifierCreated = () => {
        setAlert({
            message: "Price modifier successfully created!",
            severity: 'success'
        });
    }

    const onModifierDeleted = () => {
        setAlert({
            message: "Price modifier successfully deleted",
            severity: 'success'
        });
    }

    const onModifierUpdated = () => {
        setAlert({
            message: "Price modifier successfully updated",
            severity: 'success'
        });
    }

    const onError = (error) => {
        setAlert({
            message: error.message,
            severity: 'error'
        });
    }

    return <>
        <PriceModifiersListWrapperWithMultipleQueryData
            queryResults={{
                rooms: roomsQueryResults,
                plans: plansQueryResult,
                priceModifiers: priceModifiersQueryResult
            }}
            propertyId={propertyId}
            onCreate={onModifierCreated}
            onUpdate={onModifierUpdated}
            onDelete={onModifierDeleted}
            deletePriceModifier={deleteModifier}
            onError={onError}
        />
    </>
}

const PriceModifiersListWrapper = ({ queryResults, reloadAll, propertyId, ...props }) => {
    const navigate = useNavigate();

    const { rooms: roomsQueryResult, plans: plansQueryResult, priceModifiers: priceModifiersQueryResult } = queryResults;

    /* eslint-disable no-unused-vars */
    const { data: rooms, refetch: reloadRooms } = roomsQueryResult;
    const { data: plans, refetch: reloadPlans } = plansQueryResult;
    const { data: priceModifiers, refetch: reloadPriceModifiers } = priceModifiersQueryResult;
    /* eslint-enable no-unused-vars */

    const goToRoomsPage = () => {
        navigate('../../rooms');
    }

    const goToPlansPage = () => {
        navigate('../rate-plans');
    }

    const roomsMissing = !rooms?.length;
    const plansMissing = !plans?.length

    if (roomsMissing || plansMissing) {
        return <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
                variant="h6"
                component="div"
                sx={{ margin: '20px', textAlign: 'center' }}
            >
                Create at least one room and one rate plan in order to create Price Modifiers
            </Typography>
            <OrdinaryButton sx={{ width: '300px', height: '50px', alignSelf: 'center' }} onClick={roomsMissing ? goToRoomsPage : goToPlansPage} text={`Go to ${roomsMissing ? 'Rooms' : 'Plans'}`} />
        </Box>;
    }

    return <PriceModifiersList
        propertyId={propertyId}
        priceModifiers={priceModifiers}
        rooms={rooms}
        plans={plans}
        {...props}
    />
}

const PriceModifiersListWrapperWithMultipleQueryData = withMultipleQueryData(PriceModifiersListWrapper)

export default PriceModifiersPage;